export default "__VITE_ASSET__CiVsGKLu__"